import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyValuations } from '../propertyEndpoints'

export function usePropertyValuationsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.valuations(toValue(id)),
    queryFn: () => getPropertyValuations(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
